<template>
  <div id="firstrechargelist">
    <mt-header :title="this.$store.getters.WordsConfig.CellList.wjgl">
      <a slot="left" @click="closePopup">
        <mt-button icon="back"></mt-button>
      </a>
    </mt-header>
    <div style="position: absolute;top: 40px;left: 0;right: 0;bottom: 26px;">
      <el-table :data="tableData"
                height="100%"
                :empty-text="this.$store.getters.WordsConfig.TBEmptyText">
        <el-table-column fixed
                         prop="gameId"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.gameId"
                         header-align="center"
                         align="center"
                         width="88"></el-table-column>
        <el-table-column prop="gameAccount"
                         sortable
                         :label="this.$store.getters.WordsConfig.Recharge.gameAccount"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="payAmount"
                         sortable
                         :label="this.$store.getters.WordsConfig.Recharge.payAmount"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="orderID"
                         sortable
                         :label="this.$store.getters.WordsConfig.Recharge.OrderID"
                         width="320"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="applyDate"
                         sortable
                         :label="this.$store.getters.WordsConfig.Recharge.applyDate"
                         width="220"
                         header-align="center"
                         align="center"></el-table-column>
      </el-table>
      <el-pagination small
                     class="pagination"
                     background
                     :total="total"
                     :page-size="20"
                     layout="prev, pager, next"
                     :current-page.sync="currentPage"
                     @current-change="getNextPage"></el-pagination>
    </div>
  </div>
</template>

<script>
  import { G_FirstRechargeList } from "../../api/api.js";
  export default {
    data() {
      return {
        currentPage: 1,
        type: 0,
        tableData: [],
        total: 1,
        curPage: 0
      };
    },
    props: ["st", "et"],
    mounted() { },
    methods: {
      firData(type) {
        this.type = type;
        this.tableData = [];
        this.getData(0);
      },
      closePopup() {
        this.curPage = 0;
        this.currentPage = 1;
        this.$emit("closePopup");
      },
      getNextPage(currPage) {
        this.tableData = [];
        this.getData(currPage - 1);
      },
      getData(id) {
        console.log(this.st, this.et, id)
        this.currentPage = id+1
        G_FirstRechargeList(this.st, this.et, this.currentPage)
          .then(res => {
            console.log("G_FirstRechargeList", res.data.dataCount);
           
            this.total = res.data.dataCount;
            for (const it of res.data.data) {
              let item = {
                gameId: it.gameId,
                gameAccount: it.gameAccount,
                payAmount: it.payAmount,
                orderID: it.orderID,
                applyDate: it.applyDate
              };
             
              this.tableData.push(item);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .pagination {
    position: absolute;
    bottom: -26px;
    width: 100%;
    background: white;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cells/FirstRecharge.vue